import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const FILE_POPULATE_MUTATION = gql`
	mutation( $data: JSON, $name: String, $startDate: String, $endDate: String, $scenario: String) {
		filePopulate( data: $data, name: $name, startDate: $startDate, endDate: $endDate, scenario: $scenario)
	}
`;

export default ({ children }) => (
	<Mutation mutation={FILE_POPULATE_MUTATION} refetchQueries={['adminQuery']}>
		{filePopulate => Propagator(children, filePopulate)}
	</Mutation>
);
